import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import {Process} from '@/entity/Process';
import {General} from '@/services/General';
import { IStoreUser } from '@/interfaces/IStoreUser';
import { MenuItem } from '@/services/MenuItem';

Vue.use(Vuex);
const getDefaultState = (currentClientVersion = null) => {
    return {
        token: '',
        user: {} as IStoreUser,
        userProfile: {},
        countrySelected: {},
        claimsList: [],
        isLogged: false,
        currentPath: '',
        isMainLoading: false,
        impersonatedBy: null,
        impersonationStartDate: null,
        userToImpersonate: null,
        clientVersion: currentClientVersion,
        mandatoryCommunications: null,
        isHidingCommunicationDuringImpersonation: false,
        processList: [] as Array<Process>,
        processCount: 0,
        lastTranslationUpdate: null,
        languages: [] as Array<any>,
        singleMenuItem: {} as MenuItem,        
        isEmergencyContactExpired: null ,
    };
};
export default new Vuex.Store({
    strict: true,
    plugins: [createPersistedState()],
    state: getDefaultState(),
    getters: {
        getSingleMenuItem: state =>{
            return state.singleMenuItem;
        },
        isLoggedIn: state => {
            return state.token;
        },
        getMandatoryCommunications : state => {
            return state.mandatoryCommunications;
        },
        getCountrySelected: state => {
            return state.countrySelected;
        },
        getFatherCountry: state=>{
            if (state.countrySelected==null) return {};
            return (state.countrySelected as any).countryFather;
        },
        getUser: state => {
            return state.user;
        },
        getLastTranslationUpdate: state => {
            return state.lastTranslationUpdate;
        },
        claims: state => {
            return state.claimsList;
        },
        isLogged: state => {
            return state.isLogged;
        },
        currentPath: state => {
            return state.currentPath;
        },
        isMainLoading: state => {
            return state.isMainLoading;
        },
        impersonatedBy: state => {
            return state.impersonatedBy;
        },
        isImpersonated: state => {
            if (state.impersonatedBy != undefined && state.impersonatedBy != null) {
                return true;
            }
            return false;
        },
        isHidingCommunicationDuringImpersonation: state => {
            return state.isHidingCommunicationDuringImpersonation;
        },
        impersionationDateTime: state => {
            return state.impersonationStartDate;
        },
        impersionationDate: state => {
            return new Date(state.impersonationStartDate);
        },
        userToImpersonate: state => {
            return state.userToImpersonate;
        },
        checkClientVersion: state => {
            return state.clientVersion
        },
        getProcessList: state => {
            return General.filterProcess(state.processList);
        },
        getProcessCount: state => {
            return General.filterProcess(state.processList).length;
        },
        getLanguages: state => {
            return state.languages;
        },
        getUserProfile: state => {
            return state.userProfile;
        },
        isEmergencyContactExpired: state => {
            return state.isEmergencyContactExpired;
        }
    },
    mutations: {
        SET_SINGLEMENUITEM: (state, token) => {
            state.singleMenuItem = token;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_MANDATORYCOMMUNICATIONS:(state,mandatoryCommunications) => {
            state.mandatoryCommunications = mandatoryCommunications;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_USER_CULTURE: (state, idCulture) => {
            state.user.IdCulture = idCulture;
        },
        SET_USERPROFILE: (state, userProfile) => {
            state.userProfile = userProfile;

        },
        SET_CLAIMS: (state, claims) => {
            state.claimsList = claims;
        },
        RESET: (state, currentClientVersion) => {
            Object.assign(state, getDefaultState(currentClientVersion));
        },
        SET_ISLOGGED: (state, isLogged) => {
            state.isLogged = isLogged;
        },
        SET_PATH: (state, currentPath) => {
            state.currentPath = currentPath;
        },
        SET_LASTTRANSLATIONUPDATE:(state, lastTranslationDate) => {
            state.lastTranslationUpdate = lastTranslationDate;
        },
        SET_COUNTRYSELECTED: (state, countrySelected) => {
            state.countrySelected = countrySelected;
        },
        SET_MAINLOADING: (state, mainLoading) => {
            state.isMainLoading = mainLoading;
        },
        SET_IMPERSONATEDBY: (state, impersonatedBy) => {
            state.impersonatedBy = impersonatedBy;
        },
        SET_IMPERSIONATIONDATE: (state, impersonationStartDate) => {
            state.impersonationStartDate = impersonationStartDate;
        },
        SET_USERTOIMPERSONATE: (state, userToImpersonate) => {
            state.userToImpersonate = userToImpersonate;
        },
        SET_CLIENTVERSION: (state, clientVersion) => {
            console.log("test client " + clientVersion)
            state.clientVersion = clientVersion;
        },
        SET_ISHIDINGCOMMUNICATIONSDURINGIMPERSONATION: (state, hideCommunicationDuringImpersonation) =>{
            state.isHidingCommunicationDuringImpersonation = hideCommunicationDuringImpersonation;
        },
        SET_ISEMERGENCYCONTACTEXPIRED:(state, isExpiredEmergencyContact) => {    
            state.isEmergencyContactExpired = isExpiredEmergencyContact;
        },
        ADD_LANGUAGE: (state, language: any) => {
            state.languages.push(language);
        },
        UPDATE_LANGUAGE:(state, newLanguage: any) => {
            let oldLangIndex = state.languages.findIndex(lang => lang["idCulture"] == newLanguage.idCulture);
            console.log(oldLangIndex);
            
            if(oldLangIndex != -1){
                state.languages.splice(oldLangIndex, 1)
                state.languages[oldLangIndex] = newLanguage;
            }
        },
        ADD_PROCESS: (state, processList: Array<Process>) => {
            processList.forEach(element => {
                let index = state.processList.findIndex(element2 => element2.ProcessId === element.ProcessId);
                if(index < 0) {
                    state.processList.push(element);
                    //state.processCount = state.processList.length;
                } else {
                    state.processList[index].Percentage = element.Percentage;
                    state.processList[index].CurrentStep = element.CurrentStep;
                    state.processList[index].Status = element.Status;
                    state.processList[index].ErrorDescription = element.ErrorDescription;
                    state.processList[index].EndDate = element.EndDate;
                }
            });
        },
        CLEAR_PROCESS_LIST: (state) => {
            state.processList = [];
            state.processCount = 0;
        },
        CLEAR_ALL_REMOVABLE_PROCESS: (state) => {
            let newProcessList = [];
            state.processList.forEach(p => {
                if(p.ErrorDescription === undefined || p.ErrorDescription == null) {
                    if(p.Percentage != 100)
                        newProcessList.push(p);
                }
            });
            state.processList = newProcessList;
            state.processCount = state.processList.length;
        },
        DELETE_PROCESS: (state, processId: string) => {
            const indexToDelete = state.processList.findIndex(element => element.ProcessId === processId);
            if (indexToDelete > -1)
                state.processList.splice(indexToDelete, 1);

            state.processCount = state.processList.length;
        }
    },
    actions: {
        
        setSingleMenuItem:({commit}, isSingleMenuItem) => {            
            commit('SET_SINGLEMENUITEM', isSingleMenuItem);
        },
        login: ({ commit, dispatch }, { token, user, claims, isLogged }) => {
            commit('SET_CLAIMS', claims);
            commit('SET_TOKEN', token);
            commit('SET_USER', user);
            commit('SET_ISLOGGED', isLogged);
            commit('SET_IMPERSONATEDBY', null);
            // set auth header
            Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },        
        logout: ({ commit }, {currentClientVersion}) => {
            commit('RESET', currentClientVersion);
        },
        setCurrentPath: ({ commit, dispatch }, { currentPath }) => {
            commit('SET_PATH', currentPath);
        },
        setLoading: ({ commit, dispatch }, mainLoading) => {            
            commit('SET_MAINLOADING', mainLoading);
        },
        impersonate: ({ commit, dispatch }, { token, user, impersonatedBy, userToImpersonate, claims, isLogged }) => {
            commit('SET_CLAIMS', claims);
            commit('SET_TOKEN', token);
            commit('SET_USER', user);
            commit('SET_ISLOGGED', isLogged);
            commit('SET_IMPERSONATEDBY', impersonatedBy);
            commit('SET_IMPERSIONATIONDATE', Date.now());
            commit('SET_USERTOIMPERSONATE', userToImpersonate);
            // set auth header
            Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        setClientVersion: ({ commit, dispatch }, clientVersion) => {
            console.log("test client _1_" + clientVersion)
            commit("SET_CLIENTVERSION", clientVersion);
        },

        setUserInfo: ({ commit, dispatch }, {userProfile,claims}) => {
            commit("SET_COUNTRYSELECTED", userProfile.country);
            commit("SET_USERPROFILE", userProfile);
            commit("SET_CLAIMS", claims);
        },
        setMandatoryCommunications: ({ commit, dispatch }, mandatoryCommunications) => {
            commit("SET_MANDATORYCOMMUNICATIONS", mandatoryCommunications);
        },
        setLastTranslationUpdate: ({commit, dispatch}, lastTransaltionDate) => {
            commit("SET_LASTTRANSLATIONUPDATE", lastTransaltionDate)
        },
        setIsHidingCommunicationsDuringImpersonation: ({commit, dispatch}, hideCommunicationsDuringImpersonation)=> {
            commit("SET_ISHIDINGCOMMUNICATIONSDURINGIMPERSONATION", hideCommunicationsDuringImpersonation)
        },
        addProcess: ({commit, dispatch}, processList: Array<Process>) => {
            commit("ADD_PROCESS", processList)
        },
        clearProcessList: ({commit, dispatch}) => {
            commit("CLEAR_PROCESS_LIST")
        },
        deleteProcess: ({commit, dispatch}, processId: string) => {
            commit("DELETE_PROCESS", processId)
        },
        setUserCulture: ({commit, dispatch}, {idCulture}) => {
            commit("SET_USER_CULTURE", idCulture);
        },
        setIsEmergencyContactExpired: ({commit, dispatch}, isEmergencyContactExpired) => {
            commit("SET_ISEMERGENCYCONTACTEXPIRED", isEmergencyContactExpired);
        }
    }
});